export default "/images/bcd1bfd835f863ff737b4931a1064700.avif";